import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { smsClient } from '../client';
import type { SenderName, SenderNameCreate, SenderNameUpdate } from '../types';

export const senderNamesAdapter: CrudAdapter<SenderName, SenderNameCreate, SenderNameUpdate> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await smsClient.GET('/sender_names/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await smsClient.POST('/sender_names/', { body: payload });
    if (error) throw error;
    return { id: data?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await smsClient.PUT('/sender_names/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as SenderName;
  },
  async byKey(id) {
    const { data, error } = await smsClient.GET('/sender_names/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
    return data as SenderName;
  },
  async remove(id) {
    const { error } = await smsClient.DELETE('/sender_names/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const senderNamesStore = useCrudDataSource(senderNamesAdapter);
